// extracted by mini-css-extract-plugin
export default {"description":"ProfilePetData_description__zR09+","error":"ProfilePetData_error__d-ccM"};